import { ConfigProvider, Slider } from 'antd';
import useLocale from 'next-translate/useTranslation';
import React, { useState } from 'react';

const EarningsCalculator = () => {
  const { t } = useLocale('affiliates');
  const [unlimitedReferrals, setunlimitedReferrals] = useState(68); // Default value based on the image
  const [teamsReferrals, setTeamsReferrals] = useState(28); // Default value based on the image
  const unlimitedPlanPrice = 28;
  const teamsPlanPrice = 68;

  const calculateEarnings = () => {
    return Math.round(
      (unlimitedReferrals * unlimitedPlanPrice +
        teamsReferrals * teamsPlanPrice) *
        0.3
    );
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Slider: {
            trackBg: 'rgb(99, 102, 241)',
          },
        },
        token: {
          // Seed Token
          colorPrimary: 'rgb(99, 102, 241)',
          borderRadius: 2,

          // Alias Token
          // colorBgContainer: '#f6ffed',
        },
      }}
    >
      <div className='earnings-calculator py-24 '>
        <h1>
          {t('You can earn')}{' '}
          <span className='earnings-amount bg-gradient-to-r from-purple-400 to-pink-600 bg-clip-text text-5xl font-bold text-transparent'>
            ${calculateEarnings()}
          </span>{' '}
          {t('every month')}
        </h1>
        <p>{t('The calculation is based on monthly price')}</p>
        <div className='space-3 mb-10 flex px-5 sm:px-0'>
          <div className='slider-label'>
            <strong className='text-xl '>{t('Unlimited plan')}</strong> ($
            {unlimitedPlanPrice}/mo)
          </div>
          <Slider
            className='horizontal-slider w-3/4'
            value={unlimitedReferrals}
            onChange={(value) => setunlimitedReferrals(value)}
            min={0}
            max={200}
          />
          <div className='referrals ml-5'>
            <strong className='text-xl '>{unlimitedReferrals}</strong> {t('referrals')}
          </div>
        </div>
        <div className='space-3 flex px-5 sm:px-0'>
          <div className='slider-label'>
            <strong className='text-xl '>{t('Teams plan')}</strong> (${teamsPlanPrice}
            /mo)
          </div>
          <Slider
            className='horizontal-slider  w-3/4 text-primary-600'
            value={teamsReferrals}
            onChange={(value) => setTeamsReferrals(value)}
            min={0}
            max={80}
          />
          <div className='referrals ml-5'>
            <strong className='text-xl '>{teamsReferrals}</strong> {t('referrals')}
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default EarningsCalculator;
